import React from 'react';
//import Parser from 'html-react-parser';
import ConstantReviewData from '../../services/ConstantReviewData';
import ConstantPostData from '../../services/ConstantPostData';
//import ConstantJobData from '../../services/ConstantJobData';
//import ConstantSliderData from '../../services/ConstantSliderData';
//import ConstantFaqData from '../../services/ConstantFaqData';
//import ConstantStoryData from '../../services/ConstantStoryData';
//import { Scrollbars } from 'react-custom-scrollbars';

// const FB_IMG = 'https://storage.googleapis.com/wiser_goal/user_notif_img/facebook/facebook.svg';
// const GGL_IMG = 'https://storage.googleapis.com/wiser_goal/user_notif_img/facebook/search.svg';
// const TWT_IMG = 'https://storage.googleapis.com/wiser_goal/user_notif_img/twitter.svg';
// const STAR = '<svg xmlns = "http://www.w3.org/2000/svg" width = "15" height = "15" viewBox = "0 0 10.913 10.377" > <path id="Path_733" data-name="Path 733" d="M6.987,13.8a.32.32,0,0,1-.287-.21L5.521,9.96c-.037-.115-.1-.115-.135,0L4.207,13.59a.32.32,0,0,1-.286.208H.1c-.121,0-.139.057-.042.128L3.15,16.169a.32.32,0,0,1,.109.336L2.08,20.135c-.037.115.012.15.109.079l3.088-2.243a.32.32,0,0,1,.353,0l3.088,2.243c.1.071.146.035.109-.079l-1.179-3.63a.32.32,0,0,1,.109-.336l3.088-2.243c.1-.071.079-.128-.042-.128H6.987Z" transform="translate(0.004 -9.874)" fill="{STR_CLOR}"></path> </svg>';

let lstData = [];
//let limit = 0;
// let pageNo = 2;
// let isloadData = true;
//let sliderIndex;

//get diffrence between current time and insdt
// var timeSince = function (date) {
//   if (new Date() >= new Date(date)) {
//     var seconds = Math.floor((new Date() - new Date(date)) / 1000);
//     var interval = Math.floor(seconds / 31536000);
//     if (interval >= 1) {
//       return interval + ' years ago';
//     }
//     interval = Math.floor(seconds / 2592000);
//     if (interval >= 1) {
//       return interval + ' months ago';
//     }
//     interval = Math.floor(seconds / 86400);
//     if (interval >= 1) {
//       return interval + ' days ago';
//     }
//     interval = Math.floor(seconds / 3600);
//     if (interval >= 1) {
//       return interval + ' hours ago';
//     }
//     interval = Math.floor(seconds / 60);
//     if (interval >= 1) {
//       return interval + ' minutes ago';
//     }
//     return Math.floor(seconds) + ' seconds ago';
//   }
//   else {
//     return 'seconds ago';
//   }
// };

// let fnCountAvegage = function (data, cnf, type) {
//   let average = 0;
//   let rating = 100;
//   for (let i = 0; i < data.length; i++) {
//     average += data[i].pgrtngavg;
//     rating += data[i].pgrtngcnt ? data[i].pgrtngcnt : 0;
//   }
//   if (type == 'average') {
//     return average ? (average / data.length).toFixed(2) : 5;
//   }
//   if (type == 'star') {
//     average = average ? Math.round(average / data.length) : 5;
//     let starHTML = '';
//     for (let j = 0; j < average; j++) {
//       starHTML += STAR.replace(/{STR_CLOR}/gi, cnf.crdstrclr);
//     }
//     return starHTML;
//   }
//   if (type == 'rating') {
//     return rating;
//   }
// };

// let replaceCrdHTML = function (currCard, cnf, lstData, wid, singleField) {
//   if (document.getElementById('widget_crd_mn_div_' + wid)) {
//     let cardHTML = '';
//     let crdCLs = ' ';
//     //add class columns count wise
//     if (cnf.dclm == '1')
//       crdCLs = 'WC-col-12';
//     if (cnf.dclm == '2')
//       crdCLs = 'WC-col-6';
//     if (cnf.dclm == '3')
//       crdCLs = 'WC-col-4';
//     if (cnf.dclm == '4')
//       crdCLs = 'WC-col-3';
//     if (cnf.dclm == '5')
//       crdCLs = 'WC-col-10_2';

//     if (lstData) {
//       for (let i = 0; i < lstData.length; i++) {
//         const data = lstData[i];
//         let temp = currCard.html;
//         let img = '';
//         //for get the reviewer image
//         if (data.fa == 'googlereview' || data.fa == 'googleplace') {
//           img = GGL_IMG;
//         } else if (data.fa == 'facebookreview') {
//           img = FB_IMG;
//         } else if (data.fa == 'twitterpost') {
//           img = TWT_IMG;
//         }

//         //if star rating available,
//         let ratingHTML = '';
//         for (let ir = 0; ir < data.rtng; ir++) {
//           ratingHTML += STAR.replace(/{STR_CLOR}/gi, cnf.crdstrclr);
//         }
//         //for review text
//         let _reviewText = cnf.crditrm ? fnReviewTextDisplay(data.msg, data._id) : data.msg;

//         //for the native color
//         if (cnf && cnf.crdintclr && singleField) {
//           let ObjNative = singleField.crdntvclr[data.fa];
//           if (data.fa == 'googlereview' || data.fa == 'googleplace') {
//             temp = temp.replace(/{CRD_BG_CLR}/gi, ObjNative.crdbg);
//             temp = temp.replace(/{CRD_FNT_CLR}/gi, ObjNative.crdfclr);
//             temp = temp.replace(/{CRD_ATHR_CLR}/gi, ObjNative.crdfclr);
//           } else if (data.fa == 'facebookreview') {
//             temp = temp.replace(/{CRD_BG_CLR}/gi, ObjNative.crdbg);
//             temp = temp.replace(/{CRD_FNT_CLR}/gi, ObjNative.crdfclr);
//             temp = temp.replace(/{CRD_ATHR_CLR}/gi, ObjNative.crdfclr);
//           } else if (data.fa == 'twitterpost') {
//             temp = temp.replace(/{CRD_BG_CLR}/gi, ObjNative.crdbg);
//             temp = temp.replace(/{CRD_FNT_CLR}/gi, ObjNative.crdfclr);
//             temp = temp.replace(/{CRD_ATHR_CLR}/gi, ObjNative.crdfclr);
//           }
//         } else {
//           temp = temp.replace(/{CRD_BG_CLR}/gi, cnf.crdbg);
//           temp = temp.replace(/{CRD_FNT_CLR}/gi, cnf.crdfclr);
//           temp = temp.replace(/{CRD_ATHR_CLR}/gi, cnf.crdatclr);
//         }

//         temp = temp.replace(/{CRD_ATHR_ICN}/gi, data.piu);
//         temp = temp.replace('WC-col', 'WC-col ' + crdCLs);
//         temp = temp.replace(/{POST_ID}/gi, data._id);
//         temp = temp.replace(/crd_{DATA_ID}/gi, data._id);
//         temp = temp.replace(/{CRD_ATHR_NAME}/gi, data.un || data.fn);
//         temp = temp.replace(/{CRD_DATE}/gi, timeSince(data.insdt));
//         temp = temp.replace(/{CRD_DESC}/gi, _reviewText);
//         temp = temp.replace(/{RATING_HTML}/gi, ratingHTML);
//         temp = temp.replace(/{CDR_SRC_ICN}/gi, img);
//         temp = temp.replace(/{BG_IMG}/gi, cnf.bgimg);
//         temp = temp.replace(/{CRD_BRD_CLR}/gi, cnf.crdbrdclr);
//         temp = temp.replace(/{CRD_BRD_STL}/gi, cnf.crdbrdstl);
//         temp = temp.replace(/{CRD_GP}/gi, (cnf.crdgp / 2) + 'px');
//         temp = temp.replace(/{CRD_BRD_SZ}/gi, cnf.crdbrdsz + 'px');
//         temp = temp.replace(/{CRD_BRD_RDUS}/gi, cnf.crdbrdrd + 'px');
//         temp = temp.replace(/{CRD_SHDW_HZNTL}/gi, cnf.crdshdhz + 'px');
//         temp = temp.replace(/{CRD_SHDW_VRTCL}/gi, cnf.crdshdvl + 'px');
//         temp = temp.replace(/{CRD_SHDW_BLR}/gi, cnf.crdshdblr + 'px');
//         temp = temp.replace(/{CRD_SHDW_CLR}/gi, cnf.crdshdclr);
//         temp = temp.replace(/{CRD_FNT_SZ}/gi, cnf.crdfsz + 'px');
//         temp = temp.replace(/{CRD_SCL_ICN_CLR}/gi, cnf.crdsicnclr);
//         //temp = temp.replace(/{STR_CLOR}/gi, cnf.crdstrclr);
//         temp = temp.replace(/{CRD_DSPL_ATHR}/gi, cnf.crdiat ? 'block' : 'none');
//         temp = temp.replace(/{CRD_DSPL_TIME}/gi, cnf.crdidtm ? 'block' : 'none');
//         temp = temp.replace(/{CRD_HRF_CLR}/gi, cnf.crdlnkclr);
//         temp = temp.replace(/{IS_DSPLY_HDER}/gi, cnf.ihdr ? 'block' : 'none');
//         temp = temp.replace(/{IS_DSPL_ARW}/gi, cnf.isarw ? 'block' : 'none');
//         temp = temp.replace(/{LD_MORE_TXT}/gi, cnf.ldmrtxt);
//         temp = temp.replace(/{IS_DSPLY_CONTENT}/gi, cnf.crdihurl ? 'block' : 'none');
//         temp = temp.replace(/{IS_DSPLY_SOURCE}/gi, cnf.crdisrc ? 'flex' : 'none');
//         temp = temp.replace(/{IS_DSPL_ATH_ICN}/gi, cnf.crdiauicn ? 'block' : 'none');
//         temp = temp.replace(/{IS_DSPL_ACTN}/gi, cnf.crdiact ? 'block' : 'none');
//         temp = temp.replace(/{LYT_FNT_FMLY}/gi, cnf.lyfnfml);
//         cardHTML += temp;
//       }
//     }
//     return cardHTML;
//   }
// };

// const renderThumb = ({ style, ...props }) => {
//   const thumbStyle = {
//     borderRadius: 6,
//     backgroundColor: 'rgba(35, 49, 86, 0.8)'
//   };
//   return <div className="scroll-box scroll-stick" style={{ ...style, ...thumbStyle }} {...props} />;
// };

// const CustomScrollbars = props => (
//   <Scrollbars
//     autoHide
//     renderThumbHorizontal={renderThumb}
//     renderThumbVertical={renderThumb}
//     {...props}
//   />
// );

// const responsiveWall = function (id) {
//   const getMainDivWidth = document.getElementById('widget_crd_mn_div_' + id).offsetWidth;
//   let eleCardDiv = document.querySelectorAll('#widget_crd_mn_div_' + id + ' .WC-col');
//   for (let i = 0; i < eleCardDiv.length; i++) {
//     const oCardDiv = eleCardDiv[i];
//     let calcDivCount = Math.floor(getMainDivWidth / 320);
//     let calcDivWidth = calcDivCount > 0 ? (100 / calcDivCount) : 100;
//     if (calcDivCount == 1) {
//       oCardDiv.classList.add('WC_sngleDiv');
//     }
//     oCardDiv.style.width = calcDivWidth + '%';
//   }
// };

//function for display review text data: read more/less

// const fnReviewTextDisplay = function (reviewText, id) {
//   let showChar = 100;
//   if (reviewText && reviewText.length > showChar) {
//     let lessTxt = reviewText.substr(0, showChar);
//     reviewText = '<span id="rvewless_txt_' + id + '" data-read=' + id + ' class="Review-TextLess-block">' + lessTxt + ' <span id="rvewless_txt_' + id + '" data-read=' + id + ' class="Review-ReadLink Review-ReadMore">' + ('...Read more') + '</span></span> <span id="rvewmr_txt_' + id + '" style="display:none;" class="Review-textmore-block"> ' + reviewText + ' </span>';
//   }
//   return reviewText || '';
// };

// const readMoreClick = function () {
//   var elements = document.getElementsByClassName('Review-ReadLink');
//   Array.from(elements).forEach(function (element) {
//     element.addEventListener('click', function () {
//       let less_id = 'rvewless_txt_' + element.getAttribute('data-read');
//       let more_id = 'rvewmr_txt_' + element.getAttribute('data-read');
//       document.getElementById(less_id).style.display = 'none';
//       document.getElementById(more_id).style.display = 'block';
//     });
//   });
// };


//createModelDiv 
// var createModelDiv = function (currPopup, cnf, lstData, wid) {
//   if (currPopup && lstData) {
//     let html = currPopup.html;
//     let popupCrd = currPopup.htncrd;
//     var popupDiv = document.createElement('div');
//     popupDiv.setAttribute('id', 'widget-popup-div_');
//     document.body.appendChild(popupDiv);
//     html = html.replace(/{_ID}/gi, wid);
//     html = html.replace(/{PP_BG_CLR}/gi, cnf.ppbg);
//     html = html.replace(/{PP_BRD_SZ}/gi, cnf.ppbrdsz + 'px ');
//     html = html.replace(/{PP_BRD_STL}/gi, cnf.ppbrdstl + ' ');
//     html = html.replace(/{PP_BRD_CLR}/gi, cnf.ppbrdclr);
//     html = html.replace(/{PP_BRD_RDUS}/gi, cnf.ppbrdrd + 'px');
//     html = html.replace(/{PP_SHDW_HZNTL}/gi, cnf.ppshdhz + 'px');
//     html = html.replace(/{PP_SHDW_VRTCL}/gi, cnf.ppshdvl + 'px');
//     html = html.replace(/{PP_SHDW_BLR}/gi, cnf.ppshdblr + 'px');
//     html = html.replace(/{PP_SHDW_CLR}/gi, cnf.ppshdclr);
//     html = html.replace(/{PP_BKD_CLR}/gi, cnf.ppbkdrp || '');

//     document.getElementById('widget-popup-div_').innerHTML = html;
//     if (lstData.length > 0) {
//       let sliderHTML = '';
//       for (let i = 0; i < lstData.length; i++) {
//         const m = lstData[i];
//         //if star rating available,
//         let popupStar = '';
//         for (let ir = 0; ir < m.rtng; ir++) {
//           popupStar += STAR.replace(/{STR_CLOR}/gi, cnf.ppstrclr);
//         }

//         //select popupsource
//         let popupImg;
//         if (m.fa == 'googlereview' || m.fa == 'googleplace') {
//           popupImg = GGL_IMG;
//         }
//         else if (m.fa == 'facebookreview') {
//           popupImg = FB_IMG;
//         }
//         sliderHTML += popupCrd.replace(/{PP_ATHR_ICN}/gi, m.piu)
//           .replace(/{ID}/gi, m._id)
//           .replace(/{PP_DSPL_ATHR_ICN}/gi, cnf.ppiauicn == true ? 'block' : 'none')
//           .replace(/{PP_DSPL_ATHR_NM}/gi, cnf.ppiat == true ? 'block' : 'none')
//           .replace(/{PP_ATHR_CLR}/gi, cnf.ppatclr)
//           .replace(/{PP_DSPL_SRC_ICN}/gi, cnf.ppisrc == true ? 'block' : 'none')
//           .replace(/{PP_STR_ICN}/gi, popupStar)
//           .replace(/{PP_DSPL_DT}/gi, cnf.ppidtm == true ? 'block' : 'none')
//           .replace(/{PP_DATE}/gi, timeSince(m.insdt))
//           .replace(/{PP_ATHR_NAME}/gi, m.fn ? m.fn : m.un)
//           .replace(/{PP_DESC}/gi, m.msg ? m.msg : '')
//           .replace(/{PP_SRC_ICN}/gi, '<img src=' + popupImg + ' />');
//       }
//       document.getElementById('model-main-div_' + wid).innerHTML = sliderHTML;

//       document.getElementById('model-close-div').addEventListener('click', function () {
//         document.getElementById('popup-main-div_' + wid).classList.remove('WdGtmdl-modal-show');
//         if (document.getElementById('popup_slider_' + lstData[sliderIndex]._id)) {
//           document.getElementById('popup_slider_' + lstData[sliderIndex]._id).classList.toggle('WdGtmdl-slider-block-hide');
//         }
//       });

//       //get left right navigation event
//       if (document.getElementById('WdGtmdl-slider-nav-right') || document.getElementById('WdGtmdl-slider-nav-left')) {
//         document.getElementById('WdGtmdl-slider-nav-right').addEventListener('click', function () {
//           if (document.getElementById('popup_slider_' + lstData[sliderIndex]._id))
//             document.getElementById('popup_slider_' + lstData[sliderIndex]._id).classList.toggle('WdGtmdl-slider-block-hide');
//           sliderIndex = sliderIndex + 1;
//           if (sliderIndex > lstData.length - 1) sliderIndex = 0;
//           document.getElementById('popup_slider_' + lstData[sliderIndex]._id).classList.toggle('WdGtmdl-slider-block-hide');
//         });

//         document.getElementById('WdGtmdl-slider-nav-left').addEventListener('click', function () {
//           if (document.getElementById('popup_slider_' + lstData[sliderIndex]._id))
//             document.getElementById('popup_slider_' + lstData[sliderIndex]._id).classList.toggle('WdGtmdl-slider-block-hide');
//           sliderIndex = sliderIndex - 1;
//           if (sliderIndex == -1) sliderIndex = lstData.length - 1;
//           document.getElementById('popup_slider_' + lstData[sliderIndex]._id).classList.toggle('WdGtmdl-slider-block-hide');
//         });
//       }
//     }
//   }
// };

//function for open in model

// var openModel = function (lstData, wid) {
//   var elements = document.getElementsByClassName('WC-col');
//   Array.from(elements).forEach(function (element) {
//     element.addEventListener('click', function (e) {
//       if (e.target.classList.value.indexOf('Review-ReadLink') == -1 && element.getAttribute('data-id')) {
//         //get current index and load it in popup
//         sliderIndex = lstData.findIndex(x => x._id == element.getAttribute('data-id'));
//         document.getElementById('popup-main-div_' + wid).classList.add('WdGtmdl-modal-show');
//         //use for auto scroll at the div
//         if (document.getElementById('popup_list_' + element.getAttribute('data-id'))) {
//           document.getElementById('popup_list_' + element.getAttribute('data-id')).scrollIntoView({});
//         }
//         //use for hide show the slider in popup model 
//         if (document.getElementById('popup_slider_' + element.getAttribute('data-id'))) {
//           document.getElementById('popup_slider_' + element.getAttribute('data-id')).classList.toggle('WdGtmdl-slider-block-hide'); //slider popup display selected slide
//         }
//       }
//     });
//   });
// };


//apply custom css
// var fnAppendDynamicCss = function (cnf) {
//   if (document.getElementById('custom_style')) {
//     document.getElementById('custom_style').remove();
//   }
//   if (cnf.icss) {
//     var style = document.createElement('style');
//     style.id = 'custom_style';

//     let _inputCss = cnf.ccss ? cnf.ccss.split('}') : '';
//     let _newCss = '';
//     for (let i = 0; i < _inputCss.length; i++) {
//       const oCss = _inputCss[i];
//       if (oCss) {
//         _newCss += '#Animation_style' + oCss + '}';
//       }
//     }

//     style.innerHTML = _newCss;//'#Animation_style {' + cnf.ccss + '}';
//     document.getElementsByTagName('head')[0].appendChild(style);
//   }
// };

const PreviewCard = ({
  currLayout,
  currCard,
  currPopup,
  lstWidgetData,
  isMobileScreen,
  singleField,
  widgetById,
  wdtnm,
  cn
}) => {

  //let tempHTML = '';
  //let crdHTML = '';
  if (widgetById && widgetById.dsi && widgetById.dsi.length > 0) {
    for (let i = 0; i < widgetById.dsi.length; i++) {
      const element = widgetById.dsi[i];
      delete element.widgetById;
    }
  }
  //use for load data in pixel.js
  let configCnf = JSON.stringify(widgetById);
  configCnf = JSON.parse(configCnf);
  if (configCnf.cnf && configCnf.cnf.tlstmdr != undefined) {
    configCnf.cnf.tlstmdr = new Date(configCnf.cnf.tlstmdr).getTime();
  }
  configCnf.wln = currLayout.wln;
  configCnf.htn = currLayout.html;
  configCnf.ltn = currLayout.ltn;
  currCard ? configCnf.htncrd = currCard.html : '';
  currPopup ? configCnf.htnpp = currPopup.html : '';
  currPopup ? configCnf.htnppcrd = currPopup.htncrd : '';
  localStorage.setItem('W_DSBRD_CNFG', JSON.stringify(configCnf));
  if (cn == 'review') {
    lstWidgetData = widgetById && widgetById.dsi && widgetById.dsi.length > 0 ? lstWidgetData : ConstantReviewData;
    lstData = lstWidgetData ? lstWidgetData.filter(x => x.icrn != true) : [];
  } else if (cn == 'social') {
    ConstantPostData.map(x => { x.actn.view_count = widgetById.wdtnm == 'youtubevideogallery' ? '1M' : 0; });
    lstData = widgetById && widgetById.dsi && widgetById.dsi.length > 0 ? lstWidgetData : ConstantPostData;
  } else if (configCnf.wdtnm == 'job_board' ||
    configCnf.wdtnm == 'tool_slider' ||
    configCnf.wdtnm == 'story_widget' ||
    configCnf.wdtnm == 'faq' ||
    configCnf.wdtnm == 'feedback' ||
    configCnf.wdtnm == 'tool_restaurant' ||
    configCnf.wdtnm == 'whatsappchat' ||
    configCnf.wdtnm == 'allinonechat') {
    lstData = widgetById && widgetById.cnf.tlsdtarr && widgetById.cnf.tlsdtarr.length > 0 ? widgetById.cnf.tlsdtarr : '';
  }
  //if no data source select then pass widget name
  if (widgetById && widgetById.dsi && !widgetById.dsi.length) {
    const _arrReviewSrc = ['facebook', 'google', 'capterra'];
    for (let i = 0; i < lstData.length; i++) {
      if (wdtnm == 'allinonereview')
        lstData[i].fa = _arrReviewSrc[Math.floor(Math.random() * (_arrReviewSrc.length))] || 'google';
      else
        lstData[i].fa = wdtnm;
    }
    if (wdtnm == 'allinonereview' && localStorage.getItem('W_DSBRD_CNFG')) {
      let _cnf = JSON.parse(localStorage.getItem('W_DSBRD_CNFG'));
      _cnf.dsi = [{
        cn: 'review',
        dn: 'Google My Business',
        iin: 'google',
        pgrtngavg: 5,
        pgrtngcnt: 80,
        rmk: 'Google'
      },
      {
        cn: 'review',
        dn: 'Facebook',
        iin: 'facebook',
        pgrtngavg: 4.5,
        pgrtngcnt: 25,
        rmk: 'Facebook'
      },
      {
        cn: 'review',
        dn: 'Capterra',
        iin: 'capterra',
        pgrtngavg: 5,
        pgrtngcnt: 75,
        rmk: 'Capterra'
      }];
      localStorage.setItem('W_DSBRD_CNFG', JSON.stringify(_cnf));
    }
  }

  //
  // if (widgetById && widgetById.cnf &&
  //   widgetById.cnf.tlsdtarr && widgetById.cnf.tlsdtarr.length > 0 &&
  //   widgetById.cnf.tlsctarr && widgetById.cnf.tlsctarr.length > 0) {
  //   for (let i = 0; i < widgetById.cnf.tlsdtarr.length; i++) {
  //     let objData = widgetById.cnf.tlsctarr.filter(x => x.ct_id == widgetById.cnf.tlsdtarr[i].ct_id)[0];
  //     if (objData && objData.arrfl) {
  //       widgetById.cnf.tlsdtarr[i].arrddnfl = objData.arrfl;
  //     }
  //     if (objData && objData.arrimg1) {
  //       widgetById.cnf.tlsdtarr[i].arrimg2 = objData.arrimg1;
  //     }
  //   }
  // }

  localStorage.setItem('W_DSBRD_DATA', JSON.stringify(lstData));
  localStorage.setItem('W_DSBRD_SINGL', JSON.stringify(singleField));

  // if (currLayout && cnf) {
  //   limit = cnf.drw ? parseInt(cnf.drw) * (cnf.dclm != '0' ? parseInt(cnf.dclm) : 4) : 10;
  //   // icrnData = lstWidgetData && lstWidgetData.filter(x => x.icrn === true);
  //   tempHTML = currLayout.html;
  //   tempHTML = tempHTML.replace(/{_id}/gi, wid);
  //   tempHTML = tempHTML.replace(/{IS_DSPLY_HDER}/gi, cnf.ihdr ? 'block' : 'none');
  //   tempHTML = tempHTML.replace(/{HDER_BG_CLR}/gi, cnf.hdbg);
  //   tempHTML = tempHTML.replace(/{IS_DSPLY_HDER_LG}/gi, cnf.ilg ? 'block' : 'none');
  //   tempHTML = tempHTML.replace(/{HDER_LG_URL}/gi, cnf.lgurl);
  //   tempHTML = tempHTML.replace(/{HDER_TXT}/gi, cnf.hdttxt);
  //   tempHTML = tempHTML.replace(/{CPTR_TXT}/gi, cnf.cptxt);
  //   tempHTML = tempHTML.replace(/{BG_CLR}/gi, cnf.bgclr);
  //   tempHTML = tempHTML.replace(/{CRD_BG_CLR}/gi, cnf.crdbg);
  //   if (cnf.irspn == false) {
  //     tempHTML = tempHTML.replace(/{WIDTH}/gi, cnf.wdt + 'px');
  //     if (cnf.ihgtat)
  //       tempHTML = tempHTML.replace(/{HEIGHT}/gi, cnf.hght + 'px');
  //     else
  //       tempHTML = tempHTML.replace(/{HEIGHT}/gi, '100%');
  //   } else {
  //     tempHTML = tempHTML.replace(/{WIDTH}/gi, '100%');
  //     tempHTML = tempHTML.replace(/{HEIGHT}/gi, '100%');
  //   }
  //   tempHTML = tempHTML.replace(/{{AVERAGE}}/gi, widgetById ? fnCountAvegage(widgetById.dsi, cnf, 'average') : '5');
  //   tempHTML = tempHTML.replace(/{{STAR}}/gi, widgetById ? fnCountAvegage(widgetById.dsi, cnf, 'star') : '5');
  //   tempHTML = tempHTML.replace(/{{COUNT}}/gi, widgetById ? fnCountAvegage(widgetById.dsi, cnf, 'rating') : '100');

  //   let hdr_icon = '';
  //   let src_name = '';
  //   let appName = (widgetById && widgetById.dsi.length > 0) ? widgetById.dsi[0].iin : 'googlereview';
  //   //for get the reviewer image
  //   if (appName == 'googlereview' || appName == 'googleplace') {
  //     hdr_icon = GGL_IMG;
  //     src_name = 'Google';
  //   } else if (appName == 'facebookreview') {
  //     hdr_icon = FB_IMG;
  //     src_name = 'Facebook';
  //   } else if (appName == 'twitterpost') {
  //     hdr_icon = TWT_IMG;
  //     src_name = 'Twitter';
  //   }
  //   tempHTML = tempHTML.replace(/{{ICON}}/gi, '<img src="' + hdr_icon + '"/>');
  //   tempHTML = tempHTML.replace(/{{SOURCE}}/gi, src_name);

  //   //load loadmore btn
  //   //if (cnf.lmpst == '2') {
  //   tempHTML = tempHTML.replace(/{IS_DSPLY_LDMR}/gi, 'display:block');
  //   tempHTML = tempHTML.replace(/{LD_MORE_TXT}/gi, cnf.ldmrtxt);
  //   //}
  //   //else {
  //   //tempHTML = tempHTML.replace(/{IS_DSPLY_LDMR}/gi, 'display:none');
  //   //}

  //   setTimeout(() => {
  //     lstData = lstWidgetData && lstWidgetData.filter(x => x.icrn != true).slice(0, limit);
  //     crdHTML = replaceCrdHTML(currCard, cnf, lstData, wid, singleField);
  //     document.getElementById('widget_crd_mn_div_' + wid).innerHTML = crdHTML;

  //     //for auto height and width
  //     if (cnf && cnf.dclm == '0') { responsiveWall(wid); }

  //     //for trim content
  //     readMoreClick();

  //     //on click card open pop up
  //     if (document.getElementById('widget-popup-div_' + wid)) { document.getElementById('widget-popup-div_' + wid).remove(); }
  //     if (cnf && cnf.crdclkact == '2') {
  //       createModelDiv(currPopup, cnf, lstData, wid);
  //       openModel(lstData, wid);
  //     }

  //     //for apply custom css    
  //     fnAppendDynamicCss(cnf);
  //   }, 10);

  //   // if (document.getElementById('ldmrbtn_' + wid) && isloadData) {
  //   //   isloadData = false;
  //   //   document.getElementById('ldmrbtn_' + wid).addEventListener('click', function () {
  //   //     lstData = lstWidgetData && lstWidgetData.filter(x => x.icrn != true).slice((pageNo - 1) * limit, pageNo * limit);
  //   //     pageNo++;
  //   //     crdHTML = replaceCrdHTML(currCard, cnf, lstData, wid);
  //   //     document.getElementById('widget_crd_mn_div_' + wid).innerHTML += crdHTML;

  //   //     //for hide the load more btn
  //   //     if (lstWidgetData.length <= (pageNo * limit)) {
  //   //       document.getElementById('ldmrbtn_' + wid).style.display = 'none';
  //   //     }
  //   //   });
  //   // }
  // }

  return (
    <div className='wdgt_main_wrapp'>
      <div id='Animation_style' className={isMobileScreen ? 'wdgt-editor-preview wdgt-editor-Mobipreview' : 'wdgt-editor-preview'}>

        {/* load preview in from pixel.js */}
        <div data-id="igszatokl7pg4qf" className={isMobileScreen ? 'wIs3rwa111 wdgt-editor-preview wdgt-editor-Mobipreview' : 'wIs3rwa111 wdgt-editor-preview'}>
          <iframe className="WdGt-prev-fram" id='w1fRamW1dget' src={window.location.hostname == 'localhost' ? '/widget_preview.html' : 'widget_preview.html'} width="100%" style={{ opacity: 0 }}></iframe>
          <div id="loading">
            <div className="loader">
              <div className="spinner"></div>
            </div>
          </div>
        </div>
        {/* load preview in from pixel.js */}

        {/* <CustomScrollbars style={{ display: 'none' }}>
        {tempHTML && Parser(tempHTML)}
      </CustomScrollbars> */}
      </div>
    </div>
  );
};

export default PreviewCard;


// WEBPACK FOOTER //
// ./src/components/Widget/PreviewCard.js